import { useEffect } from 'react';
var useEffectOnce = function (effect) {
    useEffect(effect, []);
};
export default useEffectOnce;



//////////////////
// WEBPACK FOOTER
// ./~/react-use/esm/useEffectOnce.js
// module id = 183
// module chunks = 2